export const locationHistory = [
  {
    sentOn: '2025-08-28T01:00:04.000Z',
    latitude: -7.35306,
    longitude: 112.7206044,
    speed: 0,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:00:14.000Z',
    latitude: -7.353255,
    longitude: 112.7212622,
    speed: 17,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:00:24.000Z',
    latitude: -7.3533711,
    longitude: 112.7216355,
    speed: 20,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:00:34.000Z',
    latitude: -7.353555,
    longitude: 112.7221866,
    speed: 18,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:00:44.000Z',
    latitude: -7.3537905,
    longitude: 112.7228355,
    speed: 29,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:00:54.000Z',
    latitude: -7.3539866,
    longitude: 112.7234844,
    speed: 31,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:01:04.000Z',
    latitude: -7.3542616,
    longitude: 112.7242311,
    speed: 27,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:01:14.000Z',
    latitude: -7.3545633,
    longitude: 112.7249244,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:01:24.000Z',
    latitude: -7.3549805,
    longitude: 112.7258755,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:01:34.000Z',
    latitude: -7.3553261,
    longitude: 112.7268711,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:01:44.000Z',
    latitude: -7.3554283,
    longitude: 112.7278844,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:01:54.000Z',
    latitude: -7.3555083,
    longitude: 112.7285155,
    speed: 29,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:02:04.000Z',
    latitude: -7.3554594,
    longitude: 112.7290755,
    speed: 19,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:02:14.000Z',
    latitude: -7.354615,
    longitude: 112.7291022,
    speed: 38,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:02:24.000Z',
    latitude: -7.3535605,
    longitude: 112.7290755,
    speed: 40,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:02:34.000Z',
    latitude: -7.3526288,
    longitude: 112.7290044,
    speed: 35,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:02:44.000Z',
    latitude: -7.3518227,
    longitude: 112.7290844,
    speed: 32,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:02:54.000Z',
    latitude: -7.35098,
    longitude: 112.7291466,
    speed: 25,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:03:04.000Z',
    latitude: -7.3504361,
    longitude: 112.7291466,
    speed: 20,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:03:14.000Z',
    latitude: -7.3498127,
    longitude: 112.7291466,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:03:24.000Z',
    latitude: -7.3490033,
    longitude: 112.7291377,
    speed: 32,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:03:34.000Z',
    latitude: -7.3483366,
    longitude: 112.7289066,
    speed: 21,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:03:44.000Z',
    latitude: -7.34812,
    longitude: 112.7284444,
    speed: 23,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:03:54.000Z',
    latitude: -7.3477577,
    longitude: 112.7278311,
    speed: 34,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:04:04.000Z',
    latitude: -7.34715,
    longitude: 112.72712,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:04:14.000Z',
    latitude: -7.3469877,
    longitude: 112.7261155,
    speed: 45,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:04:24.000Z',
    latitude: -7.3469433,
    longitude: 112.72488,
    speed: 51,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:04:34.000Z',
    latitude: -7.3467855,
    longitude: 112.72352,
    speed: 58,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:04:44.000Z',
    latitude: -7.3464438,
    longitude: 112.7221244,
    speed: 55,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:04:54.000Z',
    latitude: -7.3464633,
    longitude: 112.7208,
    speed: 51,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:05:04.000Z',
    latitude: -7.346585,
    longitude: 112.7195111,
    speed: 49,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:05:14.000Z',
    latitude: -7.3465177,
    longitude: 112.7183111,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:05:24.000Z',
    latitude: -7.3463377,
    longitude: 112.7171377,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:05:34.000Z',
    latitude: -7.3462722,
    longitude: 112.7160355,
    speed: 42,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:05:44.000Z',
    latitude: -7.3468716,
    longitude: 112.71512,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:05:54.000Z',
    latitude: -7.3468383,
    longitude: 112.7140088,
    speed: 55,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:06:04.000Z',
    latitude: -7.3463966,
    longitude: 112.7126488,
    speed: 52,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:06:14.000Z',
    latitude: -7.3462616,
    longitude: 112.7115555,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:06:24.000Z',
    latitude: -7.3468905,
    longitude: 112.7112266,
    speed: 27,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:06:44.000Z',
    latitude: -7.3471777,
    longitude: 112.7111822,
    speed: 9,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:06:54.000Z',
    latitude: -7.3477,
    longitude: 112.71104,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:07:04.000Z',
    latitude: -7.3485666,
    longitude: 112.7104977,
    speed: 45,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:07:14.000Z',
    latitude: -7.3499327,
    longitude: 112.7100888,
    speed: 65,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:07:24.000Z',
    latitude: -7.3516522,
    longitude: 112.7097333,
    speed: 77,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:07:34.000Z',
    latitude: -7.3537861,
    longitude: 112.7093155,
    speed: 93,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:07:44.000Z',
    latitude: -7.3560566,
    longitude: 112.7087111,
    speed: 92,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:07:54.000Z',
    latitude: -7.3581316,
    longitude: 112.7079911,
    speed: 79,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:08:04.000Z',
    latitude: -7.3599305,
    longitude: 112.7072444,
    speed: 83,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:08:14.000Z',
    latitude: -7.362035,
    longitude: 112.7061866,
    speed: 101,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:08:24.000Z',
    latitude: -7.364215,
    longitude: 112.7049066,
    speed: 94,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:08:34.000Z',
    latitude: -7.3658711,
    longitude: 112.7038133,
    speed: 68,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:08:44.000Z',
    latitude: -7.367445,
    longitude: 112.7026488,
    speed: 88,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:08:54.000Z',
    latitude: -7.3693927,
    longitude: 112.7013333,
    speed: 97,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:09:04.000Z',
    latitude: -7.3716061,
    longitude: 112.70008,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:09:14.000Z',
    latitude: -7.3740133,
    longitude: 112.6990044,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:09:24.000Z',
    latitude: -7.3764722,
    longitude: 112.6981777,
    speed: 101,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:09:34.000Z',
    latitude: -7.3790172,
    longitude: 112.6976088,
    speed: 103,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:09:44.000Z',
    latitude: -7.3815316,
    longitude: 112.69728,
    speed: 103,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:09:54.000Z',
    latitude: -7.3840772,
    longitude: 112.6969244,
    speed: 95,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:10:04.000Z',
    latitude: -7.3863727,
    longitude: 112.6966666,
    speed: 87,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:10:14.000Z',
    latitude: -7.3885233,
    longitude: 112.6962933,
    speed: 90,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:10:24.000Z',
    latitude: -7.3908283,
    longitude: 112.6957866,
    speed: 98,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:10:34.000Z',
    latitude: -7.3933327,
    longitude: 112.6952711,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:10:44.000Z',
    latitude: -7.395945,
    longitude: 112.6947288,
    speed: 103,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:10:54.000Z',
    latitude: -7.398505,
    longitude: 112.6944088,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:11:04.000Z',
    latitude: -7.4011094,
    longitude: 112.69432,
    speed: 102,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:11:14.000Z',
    latitude: -7.4036766,
    longitude: 112.6944622,
    speed: 100,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:11:24.000Z',
    latitude: -7.4062133,
    longitude: 112.6948266,
    speed: 103,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:11:34.000Z',
    latitude: -7.4087455,
    longitude: 112.6951822,
    speed: 98,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:11:44.000Z',
    latitude: -7.4111283,
    longitude: 112.6953155,
    speed: 95,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:11:54.000Z',
    latitude: -7.4135616,
    longitude: 112.6952,
    speed: 98,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:12:04.000Z',
    latitude: -7.4158433,
    longitude: 112.6949066,
    speed: 90,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:12:14.000Z',
    latitude: -7.4182038,
    longitude: 112.6944088,
    speed: 100,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:12:24.000Z',
    latitude: -7.420685,
    longitude: 112.6937155,
    speed: 102,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:12:34.000Z',
    latitude: -7.423065,
    longitude: 112.6930666,
    speed: 90,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:12:44.000Z',
    latitude: -7.4252733,
    longitude: 112.6928,
    speed: 88,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:12:54.000Z',
    latitude: -7.427605,
    longitude: 112.6929511,
    speed: 96,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:13:04.000Z',
    latitude: -7.42989,
    longitude: 112.6934933,
    speed: 90,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:13:14.000Z',
    latitude: -7.43204,
    longitude: 112.69432,
    speed: 92,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:13:24.000Z',
    latitude: -7.4341844,
    longitude: 112.6952444,
    speed: 94,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:13:34.000Z',
    latitude: -7.4363727,
    longitude: 112.6960444,
    speed: 89,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:13:44.000Z',
    latitude: -7.43834,
    longitude: 112.6966044,
    speed: 62,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:13:54.000Z',
    latitude: -7.4398066,
    longitude: 112.6969511,
    speed: 66,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:14:04.000Z',
    latitude: -7.4415616,
    longitude: 112.6972533,
    speed: 76,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:14:14.000Z',
    latitude: -7.4433605,
    longitude: 112.6973688,
    speed: 55,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:14:24.000Z',
    latitude: -7.4442311,
    longitude: 112.6973777,
    speed: 15,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:14:44.000Z',
    latitude: -7.444475,
    longitude: 112.6973955,
    speed: 20,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:14:54.000Z',
    latitude: -7.4451544,
    longitude: 112.6973955,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:15:04.000Z',
    latitude: -7.4460783,
    longitude: 112.6973155,
    speed: 40,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:15:14.000Z',
    latitude: -7.4472566,
    longitude: 112.6972622,
    speed: 54,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:15:24.000Z',
    latitude: -7.4487466,
    longitude: 112.6970933,
    speed: 68,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:15:34.000Z',
    latitude: -7.4507211,
    longitude: 112.6967111,
    speed: 89,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:15:44.000Z',
    latitude: -7.452945,
    longitude: 112.6961155,
    speed: 92,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:15:54.000Z',
    latitude: -7.4553383,
    longitude: 112.6953955,
    speed: 102,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:16:04.000Z',
    latitude: -7.45789,
    longitude: 112.6946222,
    speed: 107,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:16:14.000Z',
    latitude: -7.4605866,
    longitude: 112.6937777,
    speed: 114,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:16:24.000Z',
    latitude: -7.4633266,
    longitude: 112.6928977,
    speed: 113,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:16:34.000Z',
    latitude: -7.4660277,
    longitude: 112.6919822,
    speed: 112,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:16:44.000Z',
    latitude: -7.4686555,
    longitude: 112.6910933,
    speed: 112,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:16:54.000Z',
    latitude: -7.4713866,
    longitude: 112.6902133,
    speed: 115,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:17:04.000Z',
    latitude: -7.4739511,
    longitude: 112.6894044,
    speed: 90,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:17:14.000Z',
    latitude: -7.47628,
    longitude: 112.6886933,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:17:24.000Z',
    latitude: -7.4789527,
    longitude: 112.6880177,
    speed: 109,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:17:34.000Z',
    latitude: -7.4814594,
    longitude: 112.6877777,
    speed: 103,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:17:44.000Z',
    latitude: -7.484155,
    longitude: 112.6878933,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:17:54.000Z',
    latitude: -7.4866,
    longitude: 112.6883466,
    speed: 96,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:18:04.000Z',
    latitude: -7.4889633,
    longitude: 112.6891644,
    speed: 103,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:18:14.000Z',
    latitude: -7.4913877,
    longitude: 112.6904177,
    speed: 108,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:18:24.000Z',
    latitude: -7.4937061,
    longitude: 112.6919111,
    speed: 109,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:18:34.000Z',
    latitude: -7.4959605,
    longitude: 112.6934044,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:18:44.000Z',
    latitude: -7.498195,
    longitude: 112.6948266,
    speed: 99,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:18:54.000Z',
    latitude: -7.5000916,
    longitude: 112.6960444,
    speed: 86,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:19:04.000Z',
    latitude: -7.5019683,
    longitude: 112.6972977,
    speed: 92,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:19:14.000Z',
    latitude: -7.5039844,
    longitude: 112.6985688,
    speed: 94,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:19:24.000Z',
    latitude: -7.5062316,
    longitude: 112.6994666,
    speed: 99,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:19:34.000Z',
    latitude: -7.508845,
    longitude: 112.6998488,
    speed: 108,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:19:44.000Z',
    latitude: -7.5116433,
    longitude: 112.6996266,
    speed: 113,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:19:54.000Z',
    latitude: -7.5136594,
    longitude: 112.6989244,
    speed: 69,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:20:04.000Z',
    latitude: -7.5152255,
    longitude: 112.6980977,
    speed: 79,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:20:14.000Z',
    latitude: -7.5171294,
    longitude: 112.6969511,
    speed: 92,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:20:24.000Z',
    latitude: -7.5192566,
    longitude: 112.6956977,
    speed: 105,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:20:34.000Z',
    latitude: -7.5216483,
    longitude: 112.6943022,
    speed: 113,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:20:44.000Z',
    latitude: -7.52409,
    longitude: 112.6928711,
    speed: 108,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:20:54.000Z',
    latitude: -7.5263483,
    longitude: 112.6915644,
    speed: 102,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:21:04.000Z',
    latitude: -7.5285266,
    longitude: 112.6902844,
    speed: 97,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:21:14.000Z',
    latitude: -7.5307044,
    longitude: 112.6889777,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:21:24.000Z',
    latitude: -7.5329438,
    longitude: 112.6876622,
    speed: 102,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:21:34.000Z',
    latitude: -7.5351616,
    longitude: 112.6863466,
    speed: 102,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:21:44.000Z',
    latitude: -7.5374116,
    longitude: 112.6850311,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:21:54.000Z',
    latitude: -7.5398266,
    longitude: 112.6838044,
    speed: 107,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:22:04.000Z',
    latitude: -7.5425183,
    longitude: 112.6832533,
    speed: 110,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:22:14.000Z',
    latitude: -7.5452511,
    longitude: 112.6835466,
    speed: 109,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:22:24.000Z',
    latitude: -7.5477583,
    longitude: 112.6846666,
    speed: 109,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:22:34.000Z',
    latitude: -7.5498227,
    longitude: 112.6864888,
    speed: 107,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:22:44.000Z',
    latitude: -7.55108,
    longitude: 112.68848,
    speed: 78,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:22:54.000Z',
    latitude: -7.551715,
    longitude: 112.6900533,
    speed: 47,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:23:04.000Z',
    latitude: -7.551905,
    longitude: 112.6905866,
    speed: 7,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:23:24.000Z',
    latitude: -7.55208,
    longitude: 112.6910133,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:23:34.000Z',
    latitude: -7.5524455,
    longitude: 112.6919377,
    speed: 49,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:23:44.000Z',
    latitude: -7.5530083,
    longitude: 112.6934044,
    speed: 68,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:23:54.000Z',
    latitude: -7.5537333,
    longitude: 112.6952,
    speed: 79,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:24:04.000Z',
    latitude: -7.5545105,
    longitude: 112.6971822,
    speed: 90,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:24:14.000Z',
    latitude: -7.5554483,
    longitude: 112.6995466,
    speed: 105,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:24:24.000Z',
    latitude: -7.5563994,
    longitude: 112.7019466,
    speed: 93,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:24:34.000Z',
    latitude: -7.5569183,
    longitude: 112.7041688,
    speed: 86,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:24:44.000Z',
    latitude: -7.5568511,
    longitude: 112.7063822,
    speed: 92,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:24:54.000Z',
    latitude: -7.5565583,
    longitude: 112.7088266,
    speed: 102,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:25:04.000Z',
    latitude: -7.5564138,
    longitude: 112.7114222,
    speed: 100,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:25:14.000Z',
    latitude: -7.557195,
    longitude: 112.7138666,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:25:24.000Z',
    latitude: -7.5588738,
    longitude: 112.7157777,
    speed: 97,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:25:34.000Z',
    latitude: -7.5608394,
    longitude: 112.7168444,
    speed: 87,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:25:44.000Z',
    latitude: -7.5630922,
    longitude: 112.7171288,
    speed: 90,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:25:54.000Z',
    latitude: -7.5652811,
    longitude: 112.7166222,
    speed: 91,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:26:04.000Z',
    latitude: -7.5676716,
    longitude: 112.7159022,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:26:14.000Z',
    latitude: -7.5702461,
    longitude: 112.71512,
    speed: 108,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:26:24.000Z',
    latitude: -7.5728433,
    longitude: 112.7144888,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:26:34.000Z',
    latitude: -7.5754683,
    longitude: 112.7141955,
    speed: 108,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:26:44.000Z',
    latitude: -7.5782738,
    longitude: 112.7142133,
    speed: 113,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:26:54.000Z',
    latitude: -7.5810627,
    longitude: 112.7144888,
    speed: 109,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:27:04.000Z',
    latitude: -7.583665,
    longitude: 112.7147555,
    speed: 99,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:27:14.000Z',
    latitude: -7.585985,
    longitude: 112.7148266,
    speed: 96,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:27:24.000Z',
    latitude: -7.588505,
    longitude: 112.7146844,
    speed: 103,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:27:34.000Z',
    latitude: -7.5910966,
    longitude: 112.7141244,
    speed: 105,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:27:44.000Z',
    latitude: -7.5937205,
    longitude: 112.7134222,
    speed: 110,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:27:54.000Z',
    latitude: -7.5964344,
    longitude: 112.7127111,
    speed: 111,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:28:04.000Z',
    latitude: -7.599105,
    longitude: 112.712,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:28:14.000Z',
    latitude: -7.6016155,
    longitude: 112.7113244,
    speed: 101,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:28:24.000Z',
    latitude: -7.6040127,
    longitude: 112.7106488,
    speed: 97,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:28:34.000Z',
    latitude: -7.60624,
    longitude: 112.7098488,
    speed: 92,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:28:44.000Z',
    latitude: -7.608505,
    longitude: 112.7090133,
    speed: 97,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:28:54.000Z',
    latitude: -7.6108916,
    longitude: 112.7082933,
    speed: 98,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:29:04.000Z',
    latitude: -7.6132672,
    longitude: 112.7077777,
    speed: 96,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:29:14.000Z',
    latitude: -7.6156961,
    longitude: 112.7073422,
    speed: 99,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:29:24.000Z',
    latitude: -7.6182222,
    longitude: 112.7068533,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:29:34.000Z',
    latitude: -7.6208772,
    longitude: 112.7063466,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:29:44.000Z',
    latitude: -7.6232766,
    longitude: 112.7061422,
    speed: 90,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:29:54.000Z',
    latitude: -7.62555,
    longitude: 112.7066577,
    speed: 96,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:30:04.000Z',
    latitude: -7.6279294,
    longitude: 112.7072711,
    speed: 97,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:30:14.000Z',
    latitude: -7.6302483,
    longitude: 112.7076533,
    speed: 84,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:30:24.000Z',
    latitude: -7.6325766,
    longitude: 112.70776,
    speed: 98,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:30:34.000Z',
    latitude: -7.6350688,
    longitude: 112.7076177,
    speed: 103,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:30:44.000Z',
    latitude: -7.6377633,
    longitude: 112.7071288,
    speed: 112,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:30:54.000Z',
    latitude: -7.6404866,
    longitude: 112.7064711,
    speed: 108,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:31:04.000Z',
    latitude: -7.6431677,
    longitude: 112.7061688,
    speed: 109,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:31:14.000Z',
    latitude: -7.6458666,
    longitude: 112.7062311,
    speed: 101,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:31:24.000Z',
    latitude: -7.6481361,
    longitude: 112.7066133,
    speed: 83,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:31:34.000Z',
    latitude: -7.6501733,
    longitude: 112.70696,
    speed: 89,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:31:44.000Z',
    latitude: -7.6523577,
    longitude: 112.7071644,
    speed: 90,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:31:54.000Z',
    latitude: -7.6547305,
    longitude: 112.7070044,
    speed: 97,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:32:04.000Z',
    latitude: -7.6572633,
    longitude: 112.7068,
    speed: 105,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:32:14.000Z',
    latitude: -7.6599122,
    longitude: 112.7068,
    speed: 105,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:32:24.000Z',
    latitude: -7.6625861,
    longitude: 112.7071288,
    speed: 107,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:32:34.000Z',
    latitude: -7.6652883,
    longitude: 112.7074755,
    speed: 108,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:32:44.000Z',
    latitude: -7.6679866,
    longitude: 112.7078133,
    speed: 108,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:32:54.000Z',
    latitude: -7.6707027,
    longitude: 112.7080088,
    speed: 103,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:33:04.000Z',
    latitude: -7.6732322,
    longitude: 112.7075022,
    speed: 95,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:33:14.000Z',
    latitude: -7.6756477,
    longitude: 112.7075911,
    speed: 100,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:33:24.000Z',
    latitude: -7.6779844,
    longitude: 112.7085244,
    speed: 101,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:33:34.000Z',
    latitude: -7.6798066,
    longitude: 112.7102933,
    speed: 99,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:33:44.000Z',
    latitude: -7.68126,
    longitude: 112.7124355,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:33:54.000Z',
    latitude: -7.6832705,
    longitude: 112.7141422,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:34:04.000Z',
    latitude: -7.6857272,
    longitude: 112.7150577,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:34:14.000Z',
    latitude: -7.688445,
    longitude: 112.7156177,
    speed: 112,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:34:24.000Z',
    latitude: -7.6912544,
    longitude: 112.7162133,
    speed: 114,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:34:34.000Z',
    latitude: -7.6940977,
    longitude: 112.7168088,
    speed: 115,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:34:44.000Z',
    latitude: -7.696975,
    longitude: 112.7174311,
    speed: 118,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:34:54.000Z',
    latitude: -7.6999288,
    longitude: 112.71792,
    speed: 115,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:35:04.000Z',
    latitude: -7.7027488,
    longitude: 112.7176444,
    speed: 112,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:35:14.000Z',
    latitude: -7.7052972,
    longitude: 112.7166488,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:35:24.000Z',
    latitude: -7.7074461,
    longitude: 112.7150577,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:35:34.000Z',
    latitude: -7.7091766,
    longitude: 112.7130044,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:35:44.000Z',
    latitude: -7.7108316,
    longitude: 112.7109333,
    speed: 100,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:35:54.000Z',
    latitude: -7.7124005,
    longitude: 112.7090844,
    speed: 97,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:36:04.000Z',
    latitude: -7.71435,
    longitude: 112.7075377,
    speed: 99,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:36:14.000Z',
    latitude: -7.7165933,
    longitude: 112.7064622,
    speed: 99,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:36:24.000Z',
    latitude: -7.7190133,
    longitude: 112.7059377,
    speed: 97,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:36:34.000Z',
    latitude: -7.7214338,
    longitude: 112.7059555,
    speed: 97,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:36:44.000Z',
    latitude: -7.7238688,
    longitude: 112.7065244,
    speed: 103,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:36:54.000Z',
    latitude: -7.7262877,
    longitude: 112.7076622,
    speed: 109,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:37:04.000Z',
    latitude: -7.7288433,
    longitude: 112.7089511,
    speed: 116,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:37:14.000Z',
    latitude: -7.7313383,
    longitude: 112.7103644,
    speed: 112,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:37:24.000Z',
    latitude: -7.7337172,
    longitude: 112.712,
    speed: 119,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:37:34.000Z',
    latitude: -7.7361944,
    longitude: 112.7137955,
    speed: 123,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:37:44.000Z',
    latitude: -7.7386311,
    longitude: 112.7154577,
    speed: 109,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:37:54.000Z',
    latitude: -7.741325,
    longitude: 112.7166666,
    speed: 124,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:38:04.000Z',
    latitude: -7.7444288,
    longitude: 112.7176622,
    speed: 133,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:38:14.000Z',
    latitude: -7.7476105,
    longitude: 112.7186666,
    speed: 131,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:38:24.000Z',
    latitude: -7.7505377,
    longitude: 112.7196266,
    speed: 122,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:38:34.000Z',
    latitude: -7.753365,
    longitude: 112.72072,
    speed: 120,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:38:44.000Z',
    latitude: -7.7561616,
    longitude: 112.72208,
    speed: 124,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:38:54.000Z',
    latitude: -7.7588794,
    longitude: 112.7234577,
    speed: 118,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:39:04.000Z',
    latitude: -7.7614783,
    longitude: 112.7247733,
    speed: 114,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:39:14.000Z',
    latitude: -7.7636038,
    longitude: 112.7257155,
    speed: 69,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:39:24.000Z',
    latitude: -7.7648916,
    longitude: 112.7261422,
    speed: 47,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:39:34.000Z',
    latitude: -7.766445,
    longitude: 112.7264444,
    speed: 72,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:39:44.000Z',
    latitude: -7.7685538,
    longitude: 112.7266755,
    speed: 91,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:39:54.000Z',
    latitude: -7.7710205,
    longitude: 112.7269511,
    speed: 102,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:40:04.000Z',
    latitude: -7.7737783,
    longitude: 112.7272533,
    speed: 112,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:40:14.000Z',
    latitude: -7.7765816,
    longitude: 112.7274222,
    speed: 113,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:40:24.000Z',
    latitude: -7.7794883,
    longitude: 112.72736,
    speed: 117,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:40:34.000Z',
    latitude: -7.7824322,
    longitude: 112.7270488,
    speed: 118,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:40:44.000Z',
    latitude: -7.7853383,
    longitude: 112.72648,
    speed: 117,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:40:54.000Z',
    latitude: -7.7881838,
    longitude: 112.7256888,
    speed: 116,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:41:04.000Z',
    latitude: -7.7909222,
    longitude: 112.7250488,
    speed: 108,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:41:14.000Z',
    latitude: -7.7934111,
    longitude: 112.7250666,
    speed: 85,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:41:24.000Z',
    latitude: -7.7954783,
    longitude: 112.7256177,
    speed: 87,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:41:34.000Z',
    latitude: -7.7977316,
    longitude: 112.7264977,
    speed: 105,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:41:44.000Z',
    latitude: -7.8003216,
    longitude: 112.7272266,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:41:54.000Z',
    latitude: -7.8030916,
    longitude: 112.7274577,
    speed: 114,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:42:04.000Z',
    latitude: -7.8060283,
    longitude: 112.7275111,
    speed: 116,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:42:14.000Z',
    latitude: -7.8088605,
    longitude: 112.7275377,
    speed: 107,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:42:24.000Z',
    latitude: -7.811625,
    longitude: 112.7275822,
    speed: 114,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:42:34.000Z',
    latitude: -7.8144972,
    longitude: 112.7276533,
    speed: 115,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:42:44.000Z',
    latitude: -7.8173844,
    longitude: 112.7276977,
    speed: 112,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:42:54.000Z',
    latitude: -7.8201016,
    longitude: 112.72744,
    speed: 107,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:43:04.000Z',
    latitude: -7.8226416,
    longitude: 112.7267644,
    speed: 104,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:43:14.000Z',
    latitude: -7.82477,
    longitude: 112.72536,
    speed: 98,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:43:24.000Z',
    latitude: -7.82659,
    longitude: 112.7236622,
    speed: 100,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:43:34.000Z',
    latitude: -7.828045,
    longitude: 112.7215644,
    speed: 102,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:43:44.000Z',
    latitude: -7.8293177,
    longitude: 112.7192711,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:43:54.000Z',
    latitude: -7.8306416,
    longitude: 112.7168977,
    speed: 109,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:44:04.000Z',
    latitude: -7.8319633,
    longitude: 112.7144533,
    speed: 109,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:44:14.000Z',
    latitude: -7.8332994,
    longitude: 112.7120622,
    speed: 106,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:44:24.000Z',
    latitude: -7.8348916,
    longitude: 112.7100088,
    speed: 101,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:44:34.000Z',
    latitude: -7.8368966,
    longitude: 112.7087555,
    speed: 91,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:44:44.000Z',
    latitude: -7.8391472,
    longitude: 112.7082222,
    speed: 94,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:44:54.000Z',
    latitude: -7.8415861,
    longitude: 112.7084533,
    speed: 98,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:45:04.000Z',
    latitude: -7.84396,
    longitude: 112.7092977,
    speed: 99,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:45:14.000Z',
    latitude: -7.8463116,
    longitude: 112.7098488,
    speed: 96,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:45:24.000Z',
    latitude: -7.8487761,
    longitude: 112.7097866,
    speed: 102,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:45:34.000Z',
    latitude: -7.8513572,
    longitude: 112.7089955,
    speed: 108,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:45:44.000Z',
    latitude: -7.853955,
    longitude: 112.7082044,
    speed: 107,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-08-28T01:45:54.000Z',
    latitude: -7.8566033,
    longitude: 112.7073866,
    speed: 113,
    __typename: 'vehicleRawLocation',
  },
]

export const previousAlerts = [
  {
    alertCode: 8,
    createdOn: '2025-08-28T01:45:54.000Z',
    vehicleId: 24337,
    alert: {
      alertCode: 8,
      descriptionEng: 'Overspeed',
      descriptionIdn: 'Kecepatan Melebih Batas Aman',
      fullDescriptionEng: 'The vehicle is moving faster than the set speed limit',
      fullDescriptionIdn: 'Kendaraan melaju lebih cepat dari batas kecepatan yang ditetapkan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_truck_moving.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.8593566,
    longitude: 112.7065422,
    isImportant: true,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 8,
    createdOn: '2025-08-28T01:40:44.000Z',
    vehicleId: 24337,
    alert: {
      alertCode: 8,
      descriptionEng: 'Overspeed',
      descriptionIdn: 'Kecepatan Melebih Batas Aman',
      fullDescriptionEng: 'The vehicle is moving faster than the set speed limit',
      fullDescriptionIdn: 'Kendaraan melaju lebih cepat dari batas kecepatan yang ditetapkan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_truck_moving.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.7881838,
    longitude: 112.7256888,
    isImportant: true,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 8,
    createdOn: '2025-08-28T01:35:24.000Z',
    vehicleId: 24337,
    alert: {
      alertCode: 8,
      descriptionEng: 'Overspeed',
      descriptionIdn: 'Kecepatan Melebih Batas Aman',
      fullDescriptionEng: 'The vehicle is moving faster than the set speed limit',
      fullDescriptionIdn: 'Kendaraan melaju lebih cepat dari batas kecepatan yang ditetapkan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_truck_moving.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.7091766,
    longitude: 112.7130044,
    isImportant: true,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 8,
    createdOn: '2025-08-28T01:30:14.000Z',
    vehicleId: 24337,
    alert: {
      alertCode: 8,
      descriptionEng: 'Overspeed',
      descriptionIdn: 'Kecepatan Melebih Batas Aman',
      fullDescriptionEng: 'The vehicle is moving faster than the set speed limit',
      fullDescriptionIdn: 'Kendaraan melaju lebih cepat dari batas kecepatan yang ditetapkan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_truck_moving.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.6325766,
    longitude: 112.70776,
    isImportant: true,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 8,
    createdOn: '2025-08-28T01:25:04.000Z',
    vehicleId: 24337,
    alert: {
      alertCode: 8,
      descriptionEng: 'Overspeed',
      descriptionIdn: 'Kecepatan Melebih Batas Aman',
      fullDescriptionEng: 'The vehicle is moving faster than the set speed limit',
      fullDescriptionIdn: 'Kendaraan melaju lebih cepat dari batas kecepatan yang ditetapkan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_truck_moving.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.557195,
    longitude: 112.7138666,
    isImportant: true,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 8,
    createdOn: '2025-08-28T01:21:14.000Z',
    vehicleId: 24337,
    alert: {
      alertCode: 8,
      descriptionEng: 'Overspeed',
      descriptionIdn: 'Kecepatan Melebih Batas Aman',
      fullDescriptionEng: 'The vehicle is moving faster than the set speed limit',
      fullDescriptionIdn: 'Kendaraan melaju lebih cepat dari batas kecepatan yang ditetapkan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_truck_moving.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.5329438,
    longitude: 112.6876622,
    isImportant: true,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 8,
    createdOn: '2025-08-28T01:16:34.000Z',
    vehicleId: 24337,
    alert: {
      alertCode: 8,
      descriptionEng: 'Overspeed',
      descriptionIdn: 'Kecepatan Melebih Batas Aman',
      fullDescriptionEng: 'The vehicle is moving faster than the set speed limit',
      fullDescriptionIdn: 'Kendaraan melaju lebih cepat dari batas kecepatan yang ditetapkan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_truck_moving.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.4686555,
    longitude: 112.6910933,
    isImportant: true,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 8,
    createdOn: '2025-08-28T01:09:44.000Z',
    vehicleId: 24337,
    alert: {
      alertCode: 8,
      descriptionEng: 'Overspeed',
      descriptionIdn: 'Kecepatan Melebih Batas Aman',
      fullDescriptionEng: 'The vehicle is moving faster than the set speed limit',
      fullDescriptionIdn: 'Kendaraan melaju lebih cepat dari batas kecepatan yang ditetapkan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_truck_moving.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.3840772,
    longitude: 112.6969244,
    isImportant: true,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 118,
    createdOn: '2025-08-28T01:00:51.000Z',
    vehicleId: 24337,
    alert: {
      alertCode: 118,
      descriptionEng: 'Vehicle is back Online',
      descriptionIdn: 'Kendaraan kembali Online',
      fullDescriptionEng: 'The device has lost its connection to the network',
      fullDescriptionIdn: 'Perangkat telah kehilangan koneksi ke jaringan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_device.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.35306,
    longitude: 112.7206044,
    isImportant: true,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 12,
    createdOn: '2025-08-28T01:00:04.000Z',
    vehicleId: 24337,
    alert: {
      alertCode: 12,
      descriptionEng: 'Engine On',
      descriptionIdn: 'Mesin Hidup',
      fullDescriptionEng: 'Engine turned on or off',
      fullDescriptionIdn: 'Mesin dinyalakan atau dimatikan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.35306,
    longitude: 112.7206044,
    isImportant: true,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
]

export const locationHistoryInOutGeofence = [
  {
    sentOn: '2025-09-03T06:53:55.000Z',
    latitude: -7.142645,
    longitude: 113.18084,
    speed: 24,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:54:05.000Z',
    latitude: -7.142835,
    longitude: 113.181555,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:54:12.000Z',
    latitude: -7.142981,
    longitude: 113.182061,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:54:22.000Z',
    latitude: -7.14301,
    longitude: 113.182976,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:54:27.000Z',
    latitude: -7.143086,
    longitude: 113.183491,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:54:37.000Z',
    latitude: -7.143438,
    longitude: 113.184413,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:54:47.000Z',
    latitude: -7.143875,
    longitude: 113.185395,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:54:57.000Z',
    latitude: -7.144463,
    longitude: 113.18626,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:55:07.000Z',
    latitude: -7.145086,
    longitude: 113.187195,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:55:17.000Z',
    latitude: -7.145718,
    longitude: 113.188115,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:55:27.000Z',
    latitude: -7.146391,
    longitude: 113.189096,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:55:37.000Z',
    latitude: -7.147081,
    longitude: 113.190011,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:55:47.000Z',
    latitude: -7.147746,
    longitude: 113.190875,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:55:57.000Z',
    latitude: -7.148383,
    longitude: 113.19169,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:56:07.000Z',
    latitude: -7.148981,
    longitude: 113.192465,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:56:17.000Z',
    latitude: -7.149638,
    longitude: 113.193146,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:56:27.000Z',
    latitude: -7.15034,
    longitude: 113.193801,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:56:37.000Z',
    latitude: -7.151083,
    longitude: 113.194505,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:56:47.000Z',
    latitude: -7.151853,
    longitude: 113.19522,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:56:57.000Z',
    latitude: -7.152695,
    longitude: 113.195968,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:57:07.000Z',
    latitude: -7.153518,
    longitude: 113.196695,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:57:17.000Z',
    latitude: -7.154388,
    longitude: 113.197453,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:57:27.000Z',
    latitude: -7.1552,
    longitude: 113.198171,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:57:37.000Z',
    latitude: -7.155935,
    longitude: 113.198916,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:57:47.000Z',
    latitude: -7.15667,
    longitude: 113.19967,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:57:57.000Z',
    latitude: -7.157255,
    longitude: 113.200328,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:58:07.000Z',
    latitude: -7.15785,
    longitude: 113.20099,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:58:17.000Z',
    latitude: -7.158478,
    longitude: 113.201753,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:58:27.000Z',
    latitude: -7.159101,
    longitude: 113.20254,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:58:37.000Z',
    latitude: -7.159688,
    longitude: 113.20326,
    speed: 35,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:58:47.000Z',
    latitude: -7.160258,
    longitude: 113.203968,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:58:57.000Z',
    latitude: -7.16082,
    longitude: 113.204665,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:59:07.000Z',
    latitude: -7.16146,
    longitude: 113.205485,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:59:12.000Z',
    latitude: -7.161723,
    longitude: 113.20598,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:59:22.000Z',
    latitude: -7.16219,
    longitude: 113.207006,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:59:32.000Z',
    latitude: -7.162608,
    longitude: 113.208023,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:59:42.000Z',
    latitude: -7.162951,
    longitude: 113.208996,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T06:59:52.000Z',
    latitude: -7.163243,
    longitude: 113.209998,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:00:02.000Z',
    latitude: -7.163556,
    longitude: 113.210981,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:00:10.000Z',
    latitude: -7.163828,
    longitude: 113.211755,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:00:20.000Z',
    latitude: -7.16437,
    longitude: 113.212661,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:00:28.000Z',
    latitude: -7.164865,
    longitude: 113.21329,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:00:38.000Z',
    latitude: -7.165571,
    longitude: 113.214005,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:00:48.000Z',
    latitude: -7.166188,
    longitude: 113.214736,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:00:58.000Z',
    latitude: -7.166878,
    longitude: 113.215471,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:01:08.000Z',
    latitude: -7.167603,
    longitude: 113.216063,
    speed: 35,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:01:18.000Z',
    latitude: -7.168185,
    longitude: 113.216541,
    speed: 24,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:01:28.000Z',
    latitude: -7.168671,
    longitude: 113.216951,
    speed: 19,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:01:38.000Z',
    latitude: -7.169178,
    longitude: 113.217263,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:01:48.000Z',
    latitude: -7.169841,
    longitude: 113.217658,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:01:58.000Z',
    latitude: -7.170521,
    longitude: 113.21804,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:02:08.000Z',
    latitude: -7.17115,
    longitude: 113.218416,
    speed: 28,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:02:18.000Z',
    latitude: -7.171778,
    longitude: 113.21881,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:02:26.000Z',
    latitude: -7.172288,
    longitude: 113.21919,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:02:36.000Z',
    latitude: -7.172793,
    longitude: 113.219765,
    speed: 31,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:02:46.000Z',
    latitude: -7.17326,
    longitude: 113.220306,
    speed: 19,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:02:56.000Z',
    latitude: -7.173425,
    longitude: 113.220566,
    speed: 6,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:02:58.000Z',
    latitude: -7.173425,
    longitude: 113.220566,
    speed: 0,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:14:49.000Z',
    latitude: -7.173588,
    longitude: 113.220698,
    speed: 6,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:15:19.000Z',
    latitude: -7.174381,
    longitude: 113.221698,
    speed: 22,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:15:24.000Z',
    latitude: -7.174558,
    longitude: 113.22189,
    speed: 19,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:15:36.000Z',
    latitude: -7.175215,
    longitude: 113.221685,
    speed: 22,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:15:43.000Z',
    latitude: -7.175635,
    longitude: 113.221553,
    speed: 28,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:15:50.000Z',
    latitude: -7.176193,
    longitude: 113.221483,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:15:57.000Z',
    latitude: -7.176848,
    longitude: 113.221531,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:16:03.000Z',
    latitude: -7.177466,
    longitude: 113.221683,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:16:09.000Z',
    latitude: -7.178101,
    longitude: 113.221996,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:16:19.000Z',
    latitude: -7.179211,
    longitude: 113.222673,
    speed: 52,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:16:29.000Z',
    latitude: -7.180358,
    longitude: 113.223366,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:16:39.000Z',
    latitude: -7.181416,
    longitude: 113.224011,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:16:49.000Z',
    latitude: -7.182441,
    longitude: 113.224613,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:16:59.000Z',
    latitude: -7.183521,
    longitude: 113.225153,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:17:09.000Z',
    latitude: -7.184618,
    longitude: 113.22555,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:17:14.000Z',
    latitude: -7.185208,
    longitude: 113.22572,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:17:24.000Z',
    latitude: -7.186378,
    longitude: 113.22579,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:17:34.000Z',
    latitude: -7.187515,
    longitude: 113.225843,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:17:44.000Z',
    latitude: -7.188715,
    longitude: 113.225825,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:17:54.000Z',
    latitude: -7.189971,
    longitude: 113.225708,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:18:04.000Z',
    latitude: -7.191266,
    longitude: 113.225573,
    speed: 52,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:18:14.000Z',
    latitude: -7.19255,
    longitude: 113.22546,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:18:24.000Z',
    latitude: -7.193846,
    longitude: 113.225381,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:18:34.000Z',
    latitude: -7.195145,
    longitude: 113.22528,
    speed: 52,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:18:44.000Z',
    latitude: -7.196438,
    longitude: 113.22516,
    speed: 52,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:18:54.000Z',
    latitude: -7.197743,
    longitude: 113.225041,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:19:04.000Z',
    latitude: -7.199016,
    longitude: 113.22493,
    speed: 52,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:19:14.000Z',
    latitude: -7.200275,
    longitude: 113.22482,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:19:24.000Z',
    latitude: -7.201465,
    longitude: 113.224711,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:19:34.000Z',
    latitude: -7.202591,
    longitude: 113.22461,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:19:37.000Z',
    latitude: -7.202941,
    longitude: 113.224551,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:19:44.000Z',
    latitude: -7.203756,
    longitude: 113.22456,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:19:52.000Z',
    latitude: -7.204578,
    longitude: 113.224668,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:19:59.000Z',
    latitude: -7.205276,
    longitude: 113.224898,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:20:07.000Z',
    latitude: -7.206031,
    longitude: 113.225295,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:20:12.000Z',
    latitude: -7.206391,
    longitude: 113.225583,
    speed: 35,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:20:22.000Z',
    latitude: -7.206908,
    longitude: 113.226158,
    speed: 28,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:20:32.000Z',
    latitude: -7.207235,
    longitude: 113.2266,
    speed: 11,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:20:42.000Z',
    latitude: -7.207355,
    longitude: 113.226788,
    speed: 7,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:21:22.000Z',
    latitude: -7.207453,
    longitude: 113.226953,
    speed: 9,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:21:32.000Z',
    latitude: -7.207593,
    longitude: 113.22717,
    speed: 9,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:22:42.000Z',
    latitude: -7.207823,
    longitude: 113.22753,
    speed: 15,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:22:51.000Z',
    latitude: -7.208073,
    longitude: 113.227943,
    speed: 28,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:22:55.000Z',
    latitude: -7.208331,
    longitude: 113.228126,
    speed: 31,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:23:03.000Z',
    latitude: -7.209025,
    longitude: 113.228311,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:23:13.000Z',
    latitude: -7.210048,
    longitude: 113.228371,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:23:16.000Z',
    latitude: -7.210358,
    longitude: 113.22845,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:23:22.000Z',
    latitude: -7.210945,
    longitude: 113.228725,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:23:24.000Z',
    latitude: -7.2111,
    longitude: 113.228855,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:23:26.000Z',
    latitude: -7.211225,
    longitude: 113.229018,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:23:28.000Z',
    latitude: -7.211305,
    longitude: 113.229201,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:23:31.000Z',
    latitude: -7.211338,
    longitude: 113.229526,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:23:41.000Z',
    latitude: -7.211403,
    longitude: 113.230545,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:23:51.000Z',
    latitude: -7.211468,
    longitude: 113.231663,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:24:01.000Z',
    latitude: -7.211423,
    longitude: 113.232896,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:24:06.000Z',
    latitude: -7.21137,
    longitude: 113.233478,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:24:08.000Z',
    latitude: -7.211288,
    longitude: 113.23368,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:24:15.000Z',
    latitude: -7.210993,
    longitude: 113.234428,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:24:19.000Z',
    latitude: -7.210915,
    longitude: 113.234868,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:24:29.000Z',
    latitude: -7.210853,
    longitude: 113.236005,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:24:34.000Z',
    latitude: -7.210708,
    longitude: 113.236563,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:24:44.000Z',
    latitude: -7.210223,
    longitude: 113.237671,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:24:54.000Z',
    latitude: -7.209601,
    longitude: 113.238603,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:25:04.000Z',
    latitude: -7.209096,
    longitude: 113.239253,
    speed: 24,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:25:14.000Z',
    latitude: -7.208683,
    longitude: 113.239751,
    speed: 24,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:25:24.000Z',
    latitude: -7.208193,
    longitude: 113.240271,
    speed: 28,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:25:34.000Z',
    latitude: -7.207741,
    longitude: 113.24083,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:25:44.000Z',
    latitude: -7.207215,
    longitude: 113.241416,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:25:54.000Z',
    latitude: -7.206728,
    longitude: 113.242016,
    speed: 31,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:26:04.000Z',
    latitude: -7.206281,
    longitude: 113.242695,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:26:14.000Z',
    latitude: -7.205986,
    longitude: 113.243356,
    speed: 24,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:26:24.000Z',
    latitude: -7.20574,
    longitude: 113.243935,
    speed: 22,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:26:31.000Z',
    latitude: -7.205465,
    longitude: 113.244168,
    speed: 15,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:26:40.000Z',
    latitude: -7.205081,
    longitude: 113.244216,
    speed: 15,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:26:50.000Z',
    latitude: -7.204723,
    longitude: 113.244161,
    speed: 7,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:27:13.000Z',
    latitude: -7.204596,
    longitude: 113.244688,
    speed: 20,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:27:20.000Z',
    latitude: -7.204605,
    longitude: 113.24513,
    speed: 28,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:27:28.000Z',
    latitude: -7.204751,
    longitude: 113.245815,
    speed: 35,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:27:38.000Z',
    latitude: -7.20505,
    longitude: 113.246708,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:27:44.000Z',
    latitude: -7.205216,
    longitude: 113.247325,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:27:49.000Z',
    latitude: -7.20531,
    longitude: 113.247833,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:27:59.000Z',
    latitude: -7.205628,
    longitude: 113.248796,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:28:02.000Z',
    latitude: -7.205771,
    longitude: 113.249038,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:28:04.000Z',
    latitude: -7.205895,
    longitude: 113.249178,
    speed: 35,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:28:09.000Z',
    latitude: -7.206271,
    longitude: 113.249406,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:28:16.000Z',
    latitude: -7.206738,
    longitude: 113.249633,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:28:25.000Z',
    latitude: -7.20722,
    longitude: 113.249966,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:28:32.000Z',
    latitude: -7.207505,
    longitude: 113.250351,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:28:36.000Z',
    latitude: -7.2076,
    longitude: 113.250626,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:28:46.000Z',
    latitude: -7.207696,
    longitude: 113.251251,
    speed: 20,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:29:26.000Z',
    latitude: -7.207736,
    longitude: 113.251935,
    speed: 6,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:29:46.000Z',
    latitude: -7.207723,
    longitude: 113.252258,
    speed: 7,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:30:02.000Z',
    latitude: -7.20811,
    longitude: 113.252541,
    speed: 13,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:30:12.000Z',
    latitude: -7.208483,
    longitude: 113.252843,
    speed: 22,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:30:17.000Z',
    latitude: -7.208683,
    longitude: 113.253098,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:30:21.000Z',
    latitude: -7.208806,
    longitude: 113.25337,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:30:23.000Z',
    latitude: -7.208853,
    longitude: 113.253551,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:30:33.000Z',
    latitude: -7.209041,
    longitude: 113.254296,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:30:43.000Z',
    latitude: -7.209203,
    longitude: 113.254946,
    speed: 24,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:30:53.000Z',
    latitude: -7.209331,
    longitude: 113.255588,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:31:03.000Z',
    latitude: -7.209443,
    longitude: 113.256378,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:31:13.000Z',
    latitude: -7.209596,
    longitude: 113.257233,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:31:23.000Z',
    latitude: -7.209746,
    longitude: 113.258031,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:31:33.000Z',
    latitude: -7.20995,
    longitude: 113.258781,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:31:43.000Z',
    latitude: -7.210165,
    longitude: 113.259556,
    speed: 31,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:31:53.000Z',
    latitude: -7.21041,
    longitude: 113.260281,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:32:03.000Z',
    latitude: -7.210638,
    longitude: 113.26097,
    speed: 31,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:32:13.000Z',
    latitude: -7.210971,
    longitude: 113.261726,
    speed: 31,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:32:23.000Z',
    latitude: -7.211278,
    longitude: 113.262473,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:32:33.000Z',
    latitude: -7.211576,
    longitude: 113.263173,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:32:43.000Z',
    latitude: -7.211871,
    longitude: 113.263891,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:32:53.000Z',
    latitude: -7.21211,
    longitude: 113.26444,
    speed: 17,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:33:03.000Z',
    latitude: -7.212231,
    longitude: 113.264731,
    speed: 11,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:33:13.000Z',
    latitude: -7.212351,
    longitude: 113.265186,
    speed: 24,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:33:23.000Z',
    latitude: -7.212551,
    longitude: 113.26595,
    speed: 35,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:33:33.000Z',
    latitude: -7.21278,
    longitude: 113.266931,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:33:43.000Z',
    latitude: -7.213018,
    longitude: 113.268061,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:33:53.000Z',
    latitude: -7.213228,
    longitude: 113.269173,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:34:03.000Z',
    latitude: -7.213523,
    longitude: 113.270266,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:34:13.000Z',
    latitude: -7.213843,
    longitude: 113.271403,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:34:23.000Z',
    latitude: -7.214125,
    longitude: 113.272505,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:34:33.000Z',
    latitude: -7.21435,
    longitude: 113.273626,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:34:43.000Z',
    latitude: -7.214481,
    longitude: 113.274808,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:34:53.000Z',
    latitude: -7.214583,
    longitude: 113.276035,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:35:04.000Z',
    latitude: -7.214721,
    longitude: 113.277295,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:35:14.000Z',
    latitude: -7.214851,
    longitude: 113.278415,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:35:24.000Z',
    latitude: -7.214933,
    longitude: 113.279555,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:35:34.000Z',
    latitude: -7.215023,
    longitude: 113.280601,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:35:44.000Z',
    latitude: -7.215173,
    longitude: 113.281526,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:35:54.000Z',
    latitude: -7.215306,
    longitude: 113.282473,
    speed: 35,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:36:04.000Z',
    latitude: -7.215423,
    longitude: 113.283555,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:36:14.000Z',
    latitude: -7.215595,
    longitude: 113.284683,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:36:24.000Z',
    latitude: -7.215743,
    longitude: 113.285765,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:36:34.000Z',
    latitude: -7.215956,
    longitude: 113.286908,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:36:44.000Z',
    latitude: -7.216231,
    longitude: 113.288083,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:36:54.000Z',
    latitude: -7.21652,
    longitude: 113.289266,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:37:04.000Z',
    latitude: -7.216868,
    longitude: 113.290451,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:37:14.000Z',
    latitude: -7.217163,
    longitude: 113.291698,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:37:24.000Z',
    latitude: -7.217378,
    longitude: 113.292901,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:37:34.000Z',
    latitude: -7.217415,
    longitude: 113.294116,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:37:44.000Z',
    latitude: -7.21735,
    longitude: 113.295341,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:37:54.000Z',
    latitude: -7.217266,
    longitude: 113.296546,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:38:04.000Z',
    latitude: -7.217106,
    longitude: 113.297661,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:38:14.000Z',
    latitude: -7.216878,
    longitude: 113.298671,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:38:24.000Z',
    latitude: -7.216668,
    longitude: 113.299676,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:38:30.000Z',
    latitude: -7.216661,
    longitude: 113.300301,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:38:36.000Z',
    latitude: -7.216745,
    longitude: 113.300925,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:38:46.000Z',
    latitude: -7.21702,
    longitude: 113.302053,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:38:56.000Z',
    latitude: -7.217271,
    longitude: 113.303168,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:39:06.000Z',
    latitude: -7.217551,
    longitude: 113.304316,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:39:16.000Z',
    latitude: -7.217851,
    longitude: 113.305536,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:39:23.000Z',
    latitude: -7.217956,
    longitude: 113.30638,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:39:33.000Z',
    latitude: -7.217891,
    longitude: 113.307588,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:39:40.000Z',
    latitude: -7.217708,
    longitude: 113.308411,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:39:50.000Z',
    latitude: -7.217446,
    longitude: 113.309615,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:40:00.000Z',
    latitude: -7.2174,
    longitude: 113.310861,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:40:10.000Z',
    latitude: -7.217395,
    longitude: 113.312108,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:40:20.000Z',
    latitude: -7.217313,
    longitude: 113.313358,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:40:30.000Z',
    latitude: -7.217193,
    longitude: 113.314626,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:40:40.000Z',
    latitude: -7.217046,
    longitude: 113.315858,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:40:50.000Z',
    latitude: -7.21685,
    longitude: 113.317126,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:41:00.000Z',
    latitude: -7.216558,
    longitude: 113.318376,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:41:10.000Z',
    latitude: -7.216233,
    longitude: 113.319538,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:41:20.000Z',
    latitude: -7.215873,
    longitude: 113.320736,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:41:29.000Z',
    latitude: -7.215476,
    longitude: 113.321763,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:41:39.000Z',
    latitude: -7.214963,
    longitude: 113.322816,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:41:49.000Z',
    latitude: -7.214416,
    longitude: 113.323713,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:41:52.000Z',
    latitude: -7.214245,
    longitude: 113.323985,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:42:02.000Z',
    latitude: -7.21363,
    longitude: 113.324856,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:42:12.000Z',
    latitude: -7.213045,
    longitude: 113.325741,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:42:16.000Z',
    latitude: -7.212833,
    longitude: 113.326121,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:42:26.000Z',
    latitude: -7.212523,
    longitude: 113.32713,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:42:28.000Z',
    latitude: -7.212486,
    longitude: 113.327348,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:42:31.000Z',
    latitude: -7.212491,
    longitude: 113.327691,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:42:41.000Z',
    latitude: -7.212655,
    longitude: 113.328785,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:42:51.000Z',
    latitude: -7.212821,
    longitude: 113.329958,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:43:01.000Z',
    latitude: -7.213043,
    longitude: 113.331116,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:43:11.000Z',
    latitude: -7.213261,
    longitude: 113.33222,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:43:21.000Z',
    latitude: -7.213548,
    longitude: 113.333445,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:43:31.000Z',
    latitude: -7.213903,
    longitude: 113.33474,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:43:41.000Z',
    latitude: -7.214253,
    longitude: 113.335981,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:43:51.000Z',
    latitude: -7.214606,
    longitude: 113.337255,
    speed: 52,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:44:00.000Z',
    latitude: -7.214811,
    longitude: 113.338481,
    speed: 54,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:44:10.000Z',
    latitude: -7.214915,
    longitude: 113.339853,
    speed: 54,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:44:20.000Z',
    latitude: -7.214925,
    longitude: 113.341228,
    speed: 54,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:44:30.000Z',
    latitude: -7.214835,
    longitude: 113.342625,
    speed: 56,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:44:40.000Z',
    latitude: -7.214801,
    longitude: 113.343986,
    speed: 56,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:44:50.000Z',
    latitude: -7.214793,
    longitude: 113.345411,
    speed: 56,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:45:00.000Z',
    latitude: -7.214758,
    longitude: 113.34684,
    speed: 56,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:45:10.000Z',
    latitude: -7.214771,
    longitude: 113.348195,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:45:20.000Z',
    latitude: -7.214941,
    longitude: 113.349518,
    speed: 54,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:45:30.000Z',
    latitude: -7.215078,
    longitude: 113.3509,
    speed: 56,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:45:40.000Z',
    latitude: -7.215171,
    longitude: 113.352335,
    speed: 56,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:45:50.000Z',
    latitude: -7.215231,
    longitude: 113.353675,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:46:00.000Z',
    latitude: -7.21532,
    longitude: 113.35499,
    speed: 52,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:46:10.000Z',
    latitude: -7.215508,
    longitude: 113.356335,
    speed: 54,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:46:20.000Z',
    latitude: -7.21552,
    longitude: 113.357693,
    speed: 54,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:46:30.000Z',
    latitude: -7.215578,
    longitude: 113.358983,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:46:40.000Z',
    latitude: -7.215623,
    longitude: 113.360253,
    speed: 50,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:46:50.000Z',
    latitude: -7.215703,
    longitude: 113.361498,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:47:00.000Z',
    latitude: -7.21571,
    longitude: 113.36259,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:47:10.000Z',
    latitude: -7.215731,
    longitude: 113.363623,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:47:20.000Z',
    latitude: -7.215738,
    longitude: 113.364503,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:47:30.000Z',
    latitude: -7.215746,
    longitude: 113.365098,
    speed: 20,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:47:40.000Z',
    latitude: -7.215746,
    longitude: 113.365823,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:47:50.000Z',
    latitude: -7.215806,
    longitude: 113.366695,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:48:00.000Z',
    latitude: -7.215856,
    longitude: 113.367575,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:48:10.000Z',
    latitude: -7.21592,
    longitude: 113.368671,
    speed: 44,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:48:20.000Z',
    latitude: -7.215995,
    longitude: 113.369875,
    speed: 48,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:48:30.000Z',
    latitude: -7.216025,
    longitude: 113.371178,
    speed: 52,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:48:40.000Z',
    latitude: -7.216028,
    longitude: 113.372493,
    speed: 52,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:48:50.000Z',
    latitude: -7.216096,
    longitude: 113.373836,
    speed: 52,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:49:00.000Z',
    latitude: -7.216173,
    longitude: 113.375051,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:49:10.000Z',
    latitude: -7.216186,
    longitude: 113.376166,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:49:20.000Z',
    latitude: -7.216198,
    longitude: 113.377248,
    speed: 39,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:49:30.000Z',
    latitude: -7.216221,
    longitude: 113.378238,
    speed: 41,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:49:40.000Z',
    latitude: -7.216296,
    longitude: 113.379323,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:49:51.000Z',
    latitude: -7.21641,
    longitude: 113.38064,
    speed: 46,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:50:01.000Z',
    latitude: -7.216495,
    longitude: 113.381663,
    speed: 35,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:50:11.000Z',
    latitude: -7.216586,
    longitude: 113.382388,
    speed: 24,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:50:21.000Z',
    latitude: -7.216658,
    longitude: 113.383026,
    speed: 30,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:50:31.000Z',
    latitude: -7.216753,
    longitude: 113.383925,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:50:41.000Z',
    latitude: -7.216883,
    longitude: 113.384963,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:50:51.000Z',
    latitude: -7.216935,
    longitude: 113.38609,
    speed: 43,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:51:01.000Z',
    latitude: -7.216993,
    longitude: 113.387106,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:51:11.000Z',
    latitude: -7.217098,
    longitude: 113.388015,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:51:21.000Z',
    latitude: -7.217131,
    longitude: 113.388895,
    speed: 37,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:51:31.000Z',
    latitude: -7.217106,
    longitude: 113.38974,
    speed: 26,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:51:41.000Z',
    latitude: -7.2171,
    longitude: 113.390125,
    speed: 9,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:51:51.000Z',
    latitude: -7.217105,
    longitude: 113.390556,
    speed: 17,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:52:01.000Z',
    latitude: -7.217083,
    longitude: 113.390911,
    speed: 9,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:52:11.000Z',
    latitude: -7.217093,
    longitude: 113.3912,
    speed: 15,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:52:21.000Z',
    latitude: -7.217113,
    longitude: 113.391691,
    speed: 20,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:52:31.000Z',
    latitude: -7.217151,
    longitude: 113.392126,
    speed: 11,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:52:41.000Z',
    latitude: -7.217218,
    longitude: 113.392545,
    speed: 19,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:52:51.000Z',
    latitude: -7.217275,
    longitude: 113.393035,
    speed: 17,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:53:01.000Z',
    latitude: -7.217278,
    longitude: 113.393506,
    speed: 24,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:53:11.000Z',
    latitude: -7.217253,
    longitude: 113.394193,
    speed: 31,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:53:21.000Z',
    latitude: -7.217273,
    longitude: 113.395046,
    speed: 31,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:53:31.000Z',
    latitude: -7.21731,
    longitude: 113.395956,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:53:41.000Z',
    latitude: -7.217346,
    longitude: 113.396746,
    speed: 24,
    __typename: 'vehicleRawLocation',
  },
  {
    sentOn: '2025-09-03T07:53:51.000Z',
    latitude: -7.217438,
    longitude: 113.397493,
    speed: 33,
    __typename: 'vehicleRawLocation',
  },
]
export const previousAlertsInOutGeofence = [
  {
    alertCode: 7,
    createdOn: '2025-09-03T07:53:51.000Z',
    vehicleId: 45571,
    alert: {
      alertCode: 7,
      descriptionEng: 'Exit Geofence Pasar Dharma Tanjung',
      descriptionIdn: 'Keluar Geolokasi Pasar Dharma Tanjung',
      fullDescriptionEng: 'Entering / Exiting geolocation',
      fullDescriptionIdn: 'Keluar / Masuk geolokasi',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.217438,
    longitude: 113.397493,
    isImportant: false,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 7,
    createdOn: '2025-09-03T07:51:11.000Z',
    vehicleId: 45571,
    alert: {
      alertCode: 7,
      descriptionEng: 'Enter Geofence Pasar Dharma Tanjung',
      descriptionIdn: 'Masuk Geolokasi Pasar Dharma Tanjung',
      fullDescriptionEng: 'Entering / Exiting geolocation',
      fullDescriptionIdn: 'Keluar / Masuk geolokasi',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.217098,
    longitude: 113.388015,
    isImportant: false,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 7,
    createdOn: '2025-09-03T07:46:10.000Z',
    vehicleId: 45571,
    alert: {
      alertCode: 7,
      descriptionEng: 'Exit Geofence SPPBE-ASAPERKASA ABIMULYA',
      descriptionIdn: 'Keluar Geolokasi SPPBE-ASAPERKASA ABIMULYA',
      fullDescriptionEng: 'Entering / Exiting geolocation',
      fullDescriptionIdn: 'Keluar / Masuk geolokasi',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.215508,
    longitude: 113.356335,
    isImportant: false,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 7,
    createdOn: '2025-09-03T07:46:00.000Z',
    vehicleId: 45571,
    alert: {
      alertCode: 7,
      descriptionEng: 'Enter Geofence SPPBE-ASAPERKASA ABIMULYA',
      descriptionIdn: 'Masuk Geolokasi SPPBE-ASAPERKASA ABIMULYA',
      fullDescriptionEng: 'Entering / Exiting geolocation',
      fullDescriptionIdn: 'Keluar / Masuk geolokasi',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.21532,
    longitude: 113.35499,
    isImportant: false,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 117,
    createdOn: '2025-09-03T07:24:06.000Z',
    vehicleId: 45571,
    alert: {
      alertCode: 117,
      descriptionEng: 'Excessive Driving Time',
      descriptionIdn: 'Waktu Mengemudi Berlebihan',
      fullDescriptionEng: ' The driver has exceeded the safe driving time limit',
      fullDescriptionIdn: 'Pengemudi melebihi batas waktu mengemudi yang aman',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_clock.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.211288,
    longitude: 113.23368,
    isImportant: false,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 91,
    createdOn: '2025-09-03T07:19:37.000Z',
    vehicleId: 45571,
    alert: {
      alertCode: 91,
      descriptionEng: 'Headway Monitoring Warning',
      descriptionIdn: 'Headway Monitoring Warning',
      fullDescriptionEng: 'Warns if the vehicle is too close to the one ahead',
      fullDescriptionIdn:
        'Memberi peringatan jika kendaraan terlalu dekat dengan kendaraan di depan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.202941,
    longitude: 113.224551,
    isImportant: false,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 12,
    createdOn: '2025-09-03T07:13:54.000Z',
    vehicleId: 45571,
    alert: {
      alertCode: 12,
      descriptionEng: 'Engine On',
      descriptionIdn: 'Mesin Hidup',
      fullDescriptionEng: 'Engine turned on or off',
      fullDescriptionIdn: 'Mesin dinyalakan atau dimatikan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.173588,
    longitude: 113.220698,
    isImportant: false,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 1,
    createdOn: '2025-09-03T07:05:21.000Z',
    vehicleId: 45571,
    alert: {
      alertCode: 1,
      descriptionEng: 'Device disarmed',
      descriptionIdn: 'Pelepasan GPS',
      fullDescriptionEng:
        'This notification appears when the GPS device loses power. This can happen when the GPS is disconnected from the power source. Turn it on to keep monitoring your fleet when the GPS is unplugged.',
      fullDescriptionIdn:
        'Notifikasi ini muncul ketika device GPS kehilangan daya. Hal ini bisa terjadi ketika GPS dilepas dari sumber power. Nyalakan untuk tetap menjaga armada Anda ketika GPS dicabut.',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_device.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.173453,
    longitude: 113.220585,
    isImportant: false,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 1,
    createdOn: '2025-09-03T07:03:26.000Z',
    vehicleId: 45571,
    alert: {
      alertCode: 1,
      descriptionEng: 'Device disarmed',
      descriptionIdn: 'Pelepasan GPS',
      fullDescriptionEng:
        'This notification appears when the GPS device loses power. This can happen when the GPS is disconnected from the power source. Turn it on to keep monitoring your fleet when the GPS is unplugged.',
      fullDescriptionIdn:
        'Notifikasi ini muncul ketika device GPS kehilangan daya. Hal ini bisa terjadi ketika GPS dilepas dari sumber power. Nyalakan untuk tetap menjaga armada Anda ketika GPS dicabut.',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_device.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.173453,
    longitude: 113.220585,
    isImportant: false,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
  {
    alertCode: 12,
    createdOn: '2025-09-03T07:03:21.000Z',
    vehicleId: 45571,
    alert: {
      alertCode: 12,
      descriptionEng: 'Engine Off',
      descriptionIdn: 'Mesin Mati',
      fullDescriptionEng: 'Engine turned on or off',
      fullDescriptionIdn: 'Mesin dinyalakan atau dimatikan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      enabledInRule: true,
      __typename: 'AlertCode',
    },
    latitude: -7.173425,
    longitude: 113.220566,
    isImportant: false,
    isUrgent: false,
    __typename: 'PreviousAlerts',
  },
]
